import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  width: 100%;
  height: 54vw;
  position: relative;

  ${media.medium`
    height: 34vw;
  `}
`;
